import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M16 5H3" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 12H3" }),
		/* @__PURE__ */ _jsx("path", { d: "M11 19H3" }),
		/* @__PURE__ */ _jsx("path", { d: "m15 18 2 2 4-4" })
	]
});
export default SvgListCheck;
